export default "__VITE_ASSET__PA23$62W__"